var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';
import { BackgroundProvider } from '../BackgroundContext/index.js';
import { CardProvider, useCard } from './CardContext.js';
import { CardActions, CardFooter } from './CardFooter.js';
import { CardHeader } from './CardHeader.js';
export const Card = (_a) => {
    var { children, className, padding = 'md', attached = 'none' } = _a, rest = __rest(_a, ["children", "className", "padding", "attached"]);
    let attachedClsx = '';
    if (attached === 'top')
        attachedClsx = 'sm:rounded-b-lg';
    else if (attached === 'bottom')
        attachedClsx = 'sm:rounded-t-lg';
    else
        attachedClsx = 'sm:rounded-lg';
    return (React.createElement("div", Object.assign({ className: twMerge(clsx('bg-surface-50 text-basicSurface-500 shadow flex flex-col justify-between isolate', attachedClsx, className)) }, rest),
        React.createElement(CardProvider, { padding: padding },
            React.createElement(BackgroundProvider, { backgroundType: "surface" }, children))));
};
const CardContent = (_a) => {
    var { children, className } = _a, rest = __rest(_a, ["children", "className"]);
    const { padding } = useCard();
    return (React.createElement("div", Object.assign({ className: twMerge(clsx('flex-1', padding === 'md' && 'px-4 py-5 sm:p-6', padding === 'sm' && 'px-4 py-5 sm:px-3', className)) }, rest), children));
};
const CardMedia = (_a) => {
    var { children, className } = _a, rest = __rest(_a, ["children", "className"]);
    return (React.createElement("div", Object.assign({ className: className }, rest), children));
};
Card.Header = CardHeader;
Card.Content = CardContent;
Card.Footer = CardFooter;
Card.Media = CardMedia;
Card.Actions = CardActions;
//# sourceMappingURL=Card.js.map